module.exports = __webpack_public_path__ + "img/text_area.f9a8e5a0.svg";